<template>
  <footer ref="contentFooter">
    <ul class="footer-info">
      <li>
        <u>Project</u>
        <slot name="projectTitle" />
      </li>
      <li>
        <u>Year</u>
        <slot name="year" />
      </li>
      <li>
        <u>Team</u>
        <slot name="team" />
      </li>
      <li>
        <u>Participation</u>
        <slot name="participation" />
      </li>
    </ul>

    <router-link :to="{ path: '/works/' + nextSlug }">
      <div class="footer-next" :style="nextProjectStyle">
        <hgroup>
          <i>Next project</i>
          <slot name="nextProject"></slot>
        </hgroup>
      </div>
    </router-link>
  </footer>
</template>

<script>
  export default {
    name: 'project-footer',
    props: ['nextSlug', 'nextBgColor'],
    computed: {
      nextProjectStyle () {
        return 'background-color: ' + this.nextBgColor
      }
    },
    mounted () {
      this.$refs.contentFooter.classList.add('loaded')
    }
  }
</script>

<style lang="scss" scoped>

  footer {
    overflow: hidden;
    opacity: 0;
    transition: opacity 0.2s linear;
    transition-delay: 0.2s;

    &.loaded {
      opacity: 1;
    }
  }

  ul {
    display: block;
    width: 100%;
    max-width: 1140px;
    margin: 0 auto 150px auto;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
      margin: 0 auto 100px auto;
    }
    
    & li {
      font-size: 0.9rem;
      line-height: 2rem;
    }

    & u {
      display: inline-block;
      font-weight: 500;
      text-decoration: none;
      min-width: 150px;
    }
  
    & i {
      display: inline-block;
      font-style: normal;
      opacity: 0.8;
    }
  }

  .footer-next {
    width: 100%;
    height: 400px;
    background-color: $color-ghost;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.2s linear;

    &:hover {
      opacity: 0.9;
    }

    @include device(laptop) {
      height: 40vw;
      max-height: 400px;
      min-height: 200px;
    }

    & hgroup {
      width: 100%;
      max-width: $size-max-width;

      @include device(laptop) {
        padding: 0 60px;
      }

      @include device(mobile) {
        padding: 0 20px;
      }

      & i {
        display: inline-block;
        font-style: normal;
        font-size: 1rem;
        line-height: 30px;
        color: #fff;
        margin-bottom: 20px;
      }
    }// hgroup
  }

</style>


// WEBPACK FOOTER //
// src/components/ProjectFooter.vue